(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9786],{

/***/ 64821:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/back-arrow.e6d9293c.svg","height":19,"width":25});

/***/ }),

/***/ 39306:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/email.b2f119d5.svg","height":20,"width":28});

/***/ }),

/***/ 52324:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/phone-icon.92125abd.svg","height":22,"width":19});

/***/ }),

/***/ 2788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_ContactUs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/startCase.js
var startCase = __webpack_require__(18029);
var startCase_default = /*#__PURE__*/__webpack_require__.n(startCase);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./i18n/useContactUsi18n.js

const useContactUsi18n = (componentProps)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    var ref, ref1;
    const i18n = {
        requiredInfoText: t("kf.auth.label.requiredFields"),
        contactUsDisplayName: t("kf.contactus.label.contactUsDisplayName"),
        contactUsDescription: t("kf.contactus.label.contactUsDescription"),
        installationQuestion: t("kf.contactus.label.installationQuestion"),
        yes: t("kf.contactus.label.yes"),
        no: t("kf.contactus.label.no"),
        aTopic: t("kf.contactus.label.aTopic"),
        installationDetails: t("kf.contactus.label.installationDetails"),
        selectProductType: t("kf.contactus.label.selectProductType"),
        serialNumber: t("kf.contactus.label.serialNumber"),
        modelNumber: t("kf.contactus.label.modelNumber"),
        whereToFind: t("kf.registerOfflineProduct.label.whereToFind"),
        kohler: t("kf.registerOfflineProduct.label.kohler"),
        sterlingProduct: t("kf.registerOfflineProduct.label.sterlingProduct"),
        yourorder: t("kf.registerOfflineProduct.label.yourorder"),
        productLabel: t("kf.registerOfflineProduct.label.productLabel"),
        productLiterature: t("kf.registerOfflineProduct.label.productLiterature"),
        invoice: t("kf.registerOfflineProduct.label.invoice"),
        stamped: t("kf.registerOfflineProduct.label.stamped"),
        troubleShooting: t("kf.registerOfflineProduct.label.troubleShooting"),
        findModelNumberQuestion: t("kf.contactus.label.findModelNumberQuestion"),
        placeOfPurchase: t("kf.contactus.label.placeOfPurchase"),
        placeOfPurchaseType: t("kf.contactus.label.placeOfPurchaseType"),
        monthOfInstallation: t("kf.contactus.label.monthOfInstallation"),
        yearOfInstallation: t("kf.contactus.label.yearOfInstallation"),
        contactInformation: t("kf.contactus.label.contactInformation"),
        companyName: t("kf.contactus.label.companyName"),
        fname: t("kf.contactus.label.firstName"),
        lname: t("kf.contactus.label.lastName"),
        email: t("kf.contactus.label.emailAddress"),
        cemail: t("kf.contactus.label.confirmEmailAddress"),
        businessType: t("kf.contactus.label.businessType"),
        typeOf: t("kf.contactus.label.typeOf"),
        address: t("kf.contactus.label.address"),
        aptFloorSuite: t("kf.contactus.label.aptFloorSuite"),
        city: t("kf.contactus.label.city"),
        state: t("kf.contactus.label.state"),
        zipcode: t("kf.contactus.label.zipCode"),
        country: t("kf.contactus.label.country"),
        phoneNumber: t("kf.contactus.label.phoneNumber"),
        workingWithProfessional: t("kf.contactus.label.workingWithProfessional"),
        nameOfTheCompany: t("kf.contactus.label.nameOfTheCompany"),
        requestDetail: t("kf.contactus.label.requestDetail"),
        messageLabel: t("kf.contactus.label.messageLabel"),
        uploadPhoto: t("kf.contactus.label.uploadPhoto"),
        uploadCountLimit: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.errorMessage) || t("kf.contactus.label.uploadCountLimit"),
        uploadFileTypes: t("kf.contactus.label.uploadFileTypes"),
        uploadFileExtn: t("kf.contactus.label.uploadFileExtn"),
        uploadSizeLimit: t("kf.contactus.label.uploadSizeLimit"),
        uploadMBLimit: t("kf.contactus.label.uploadMBLimit"),
        dragAndDrop: t("kf.contactus.label.dragAndDrop"),
        orText: t("kf.contactus.label.orText"),
        uploadFileButton: t("kf.contactus.label.uploadFileButton"),
        submitButton: t("kf.contactus.label.submitButton"),
        privacyPolicy: t("kf.contactus.label.privacyPolicy"),
        subjectAccessRequest: t("kf.contactus.label.subjectAccessRequest"),
        termsOfService: t("kf.contactus.label.termsOfService"),
        backToContactUs: t("kf.contactus.label.backToContactUs"),
        messageSent: (ref = componentProps === null || componentProps === void 0 ? void 0 : componentProps.messageSent) !== null && ref !== void 0 ? ref : t("kf.contactus.label.messageSent"),
        responseReceiveTime: (ref1 = componentProps === null || componentProps === void 0 ? void 0 : componentProps.responseReceiveTime) !== null && ref1 !== void 0 ? ref1 : t("kf.contactus.label.responseReceiveTime"),
        continueShopping: t("kf.contactus.label.continueShopping"),
        fnameError: t("kf.contactus.error.fnameError"),
        lnameError: t("kf.contactus.error.lnameError"),
        noEmailError: t("kf.contactus.error.noEmailError"),
        validEmail: t("kf.contactus.error.validEmail"),
        confirmEmailError: t("kf.contactus.error.confirmEmailError"),
        emailMatchError: t("kf.contactus.error.emailMatchError"),
        noCompanyError: t("kf.contactus.error.noCompanyError"),
        businessTypeError: t("kf.contactus.error.businessTypeError"),
        subTypeError: t("kf.contactus.error.subTypeError"),
        addressError: t("kf.contactus.error.addressError"),
        cityError: t("kf.contactus.error.cityError"),
        stateError: t("kf.contactus.error.stateError"),
        zipcodeError: t("kf.contactus.error.zipcodeError"),
        validZipcode: t("kf.contactus.error.validZipcode"),
        cityStateZipMismatchError: t("kf.contactus.error.cityStateZipMismatchError"),
        countryError: t("kf.contactus.error.countryError"),
        validPhone: t("kf.contactus.error.validPhone"),
        noPhoneError: t("kf.contactus.error.noPhoneError"),
        fileLimitExceededError: t("kf.contactus.error.fileLimitExceededError"),
        protectedByGoogle: t("kf.contactus.message.protectedByGoogle"),
        productNumberError: t("kf.contactus.error.productNumberError"),
        apply: t("kf.global.label.apply"),
        errorFileType: t("kf.contactus.error.fileType"),
        errorMaxFileLimit: t("kf.contactus.error.maxFileLimit"),
        errorMaxFileSizeLimit: t("kf.contactus.error.maxFileSizeLimit"),
        installationDate: t("kf.contactus.label.installationDate"),
        installationDateValidError: t("kf.contactus.error.installationDateValidError"),
        serverError: t("kf.contactus.error.serverError"),
        businessAddress: t("kf.contactus.label.businessAddress"),
        businessPhone: t("kf.contactus.label.businessPhone"),
        home: t("kf.global.label.home"),
        helpTopic: t("kf.contactus.error.aTopic"),
        needHelp: t("kf.contactus.label.needHelp"),
        genError: t("kf.error.message.genericError"),
        emailIcon: t("kf.registration.label.email"),
        phone: t("kf.checkout.label.phone"),
        icon: t("kf.technical.label.icon"),
        ariaLabels: {
            imageRemove: t("kf.registerOfflineProduct.label.aria.removeImage")
        },
        commentBoxPlaceholder: t("kf.registerOfflineProduct.label.addComment"),
        productType: t("kf.contactus.error.productType"),
        contactName: t("kf.contactus.label.name"),
        selectTypeOfSupport: t("kf.contactus.label.selectTypeOfSupport"),
        howCanWeHelp: t("kf.contactus.label.selectedSupportError"),
        requestDetailHeading: t("kf.contactus.label.requestDetailHeading"),
        businessName: t("kf.registration.label.busniessName"),
        contactNameError: t("kf.contactus.label.nameError"),
        companyNameError: t("kf.contactus.label.nameOfTheCompanyError")
    };
    return i18n;
};
/* harmony default export */ var i18n_useContactUsi18n = (useContactUsi18n);

// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/ContactUs/v1/contactUsAnalytics.js
const getEventInfo = (type, link)=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "support:contact:main content area:" + type,
        eventName: "support:contact:main content area:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "contact us",
        internalLinkType: "support:contact:navigation",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        internalLinkZoneName: "support:contact:main content area​"
    });
};
const getAnalyticsData = (analyticsData, label)=>{
    let jsonAnalyticsData = null;
    if (analyticsData) {
        jsonAnalyticsData = JSON.parse(analyticsData);
        Object.keys(jsonAnalyticsData).forEach((key)=>{
            if (jsonAnalyticsData[key]) {
                jsonAnalyticsData[key] = jsonAnalyticsData[key].replace("{?}", label === null || label === void 0 ? void 0 : label.toLowerCase());
            }
        });
    }
    return JSON.stringify(jsonAnalyticsData);
};
const analyticsOnDelete = (activeTabForAnalytics)=>{
    const eventInfo = {
        eventAction: "support:contact:form:".concat(activeTabForAnalytics, ":remove file"),
        eventName: "support:contact:form:".concat(activeTabForAnalytics, ":remove file"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "remove file",
        internalLinkPosition: "support:contact",
        internalLinkType: "support:contact:navigation",
        internalLinkZoneName: "support:contact:form",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo: eventInfo,
        page: page
    });
};

;// CONCATENATED MODULE: ./components/ContactUs/v1/FormTabs.jsx






const FormTabs = (props)=>{
    const { activeTab ="" , label =[] , changeActive =()=>{} , analyticsData =""  } = props;
    const tabRefs = (0,react.useRef)([]);
    const { CREATE_ACCOUNT_TYPE: { HOME_OWNER ="" , TRADE_ACCOUNT =""  }  } = constants["default"];
    const HOME_OWNER_TAB = startCase_default()(HOME_OWNER);
    const TRADE_TAB = startCase_default()(TRADE_ACCOUNT);
    const handleKeyPress = (e, index)=>{
        const { keyCode: tabKeycode = ""  } = e;
        if (tabKeycode === 37 && activeTab === TRADE_TAB) {
            var ref;
            changeActive(HOME_OWNER_TAB);
            (ref = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index - 1]) === null || ref === void 0 ? void 0 : ref.focus();
        } else if (tabKeycode === 39 && activeTab === HOME_OWNER_TAB) {
            var ref1;
            changeActive(TRADE_TAB);
            (ref1 = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index + 1]) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tabs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            id: "contactus-tab-list",
            className: "tab-list",
            role: "tablist",
            children: label === null || label === void 0 ? void 0 : label.map((l, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    ref: (el)=>tabRefs.current[index] = el,
                    id: "".concat(l, "-tab"),
                    role: "tab",
                    "aria-selected": activeTab === l,
                    tabIndex: activeTab === l ? 0 : -1,
                    className: classnames_default()({
                        "tab-list-item": true,
                        "tab-list-active": activeTab === l,
                        "gbh-data-layer": true
                    }),
                    onClick: ()=>changeActive(l),
                    onKeyDown: (e)=>handleKeyPress(e, index),
                    "data-gbh-data-layer": "".concat(getAnalyticsData(analyticsData, l)),
                    children: l
                }, l))
        })
    });
};
/* harmony default export */ var v1_FormTabs = (FormTabs);

// EXTERNAL MODULE: ./src/components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(14629);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var dist_es = __webpack_require__(68901);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./public/icons/pdf-grey.svg
var pdf_grey = __webpack_require__(1405);
;// CONCATENATED MODULE: ./components/ContactUs/v1/UploadImage.jsx











const UploadImage = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const [errors, setErrors] = (0,react.useState)([]);
    const [status, setStatus] = (0,react.useState)("");
    const { imageList =[] , updateList =()=>{} , i18n ={} , activeTab ="" , buttonAnalyticsData =""  } = props;
    const activeTabForAnalytics = activeTab && (activeTab === null || activeTab === void 0 ? void 0 : activeTab.toLowerCase());
    const onDrop = async (acceptedFiles, rejectedFiles)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        const errList = (ref = rejectedFiles[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : ref1.map((el)=>{
            return el === null || el === void 0 ? void 0 : el.message;
        });
        errList && setErrors(errList);
        if (!errList && (errors === null || errors === void 0 ? void 0 : errors.length) > 0) setErrors([]);
        if ((imageList === null || imageList === void 0 ? void 0 : imageList.length) + (acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.length) <= 5) {
            setErrors([]);
            try {
                const newImageList = await Promise.all(acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.map(async (f)=>{
                    const res = await dispatch((0,genericSlice/* uploadImage */.Ix)(f)).unwrap();
                    return Object.assign(f, {
                        preview: URL.createObjectURL(f),
                        comment: "",
                        link: res === null || res === void 0 ? void 0 : res.path,
                        textCount: 0
                    });
                }));
                updateList([
                    ...imageList,
                    ...newImageList
                ]);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.log(err);
            }
        } else {
            setErrors([
                i18n === null || i18n === void 0 ? void 0 : i18n.uploadCountLimit
            ]);
        }
        if (((ref3 = (ref2 = rejectedFiles[0]) === null || ref2 === void 0 ? void 0 : ref2.errors[0]) === null || ref3 === void 0 ? void 0 : ref3.code) === "file-invalid-type") setErrors([
            i18n === null || i18n === void 0 ? void 0 : i18n.errorFileType
        ]);
        if ((rejectedFiles === null || rejectedFiles === void 0 ? void 0 : rejectedFiles.length) > 5) setErrors([
            i18n === null || i18n === void 0 ? void 0 : i18n.uploadCountLimit
        ]);
        if (((ref4 = rejectedFiles[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.file) === null || ref5 === void 0 ? void 0 : ref5.size) > 5e6) setErrors([
            i18n === null || i18n === void 0 ? void 0 : i18n.errorMaxFileSizeLimit
        ]);
    };
    const validator = (file)=>{
        if ((file === null || file === void 0 ? void 0 : file.size) > 5e6) {
            return {
                message: i18n === null || i18n === void 0 ? void 0 : i18n.errorMaxFileSizeLimit
            };
        }
        switch(file === null || file === void 0 ? void 0 : file.type){
            case "image/jpeg":
            case "image/png":
            case "image/gif":
            case "application/pdf":
                break;
            default:
                return {
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.errorFileType
                };
        }
    };
    const { getRootProps , getInputProps  } = (0,dist_es/* useDropzone */.uI)({
        accept: "image/png, image/jpg, image/jpeg, image/gif, application/pdf",
        maxFiles: 5,
        multiple: true,
        onDrop,
        validator
    });
    const onAddComment = (v, id)=>{
        const newList = imageList;
        newList[id]["comment"] = v;
        newList[id]["textCount"] = v === null || v === void 0 ? void 0 : v.length;
        updateList([
            ...newList
        ]);
    };
    const onDelete = (id)=>{
        var ref;
        const newList = imageList === null || imageList === void 0 ? void 0 : imageList.filter((l)=>l !== id);
        analyticsOnDelete(activeTabForAnalytics, id);
        updateList(newList);
        setStatus(i18n === null || i18n === void 0 ? void 0 : (ref = i18n.ariaLabels) === null || ref === void 0 ? void 0 : ref.imageRemove);
    };
    const handleFocus = (e)=>{
        const { currentTarget: { classList ={}  } = {}  } = e;
        classList === null || classList === void 0 ? void 0 : classList.add("active-comment");
    };
    const handleBlur = (e)=>{
        const { currentTarget: { classList ={}  } = {}  } = e;
        classList === null || classList === void 0 ? void 0 : classList.remove("active-comment");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "upload-image-container ".concat((imageList === null || imageList === void 0 ? void 0 : imageList.length) < 6 && (imageList === null || imageList === void 0 ? void 0 : imageList.length) !== 0 ? "file-5" : ""),
        id: "contact-image-preview-container",
        tabIndex: "0",
        role: "presentation",
        children: [
            imageList === null || imageList === void 0 ? void 0 : imageList.map((f, i)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    id: "input-id-active",
                    className: "contact-us-image-preview",
                    onClick: handleFocus,
                    onBlur: handleBlur,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "preview-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: classnames_default()({
                                    "image-box": (f === null || f === void 0 ? void 0 : f.type) !== "application/pdf"
                                }),
                                src: (f === null || f === void 0 ? void 0 : f.type) === "application/pdf" ? pdf_grey/* default */.Z === null || pdf_grey/* default */.Z === void 0 ? void 0 : pdf_grey/* default.src */.Z.src : f === null || f === void 0 ? void 0 : f.preview,
                                alt: f === null || f === void 0 ? void 0 : f.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                            id: "image-placeholder-".concat(i),
                            placeholder: i18n === null || i18n === void 0 ? void 0 : i18n.commentBoxPlaceholder,
                            value: f === null || f === void 0 ? void 0 : f.comment,
                            onChange: (e)=>onAddComment(e.target.value, i),
                            maxLength: 100
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-count",
                            children: [
                                f === null || f === void 0 ? void 0 : f.textCount,
                                " / 100"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "image-delete",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                tabIndex: "0",
                                className: "custom-close-icone",
                                onClick: ()=>onDelete(f),
                                src: icons_close/* default */.Z === null || icons_close/* default */.Z === void 0 ? void 0 : icons_close/* default.src */.Z.src,
                                alt: "close"
                            })
                        })
                    ]
                }, i);
            }),
            (imageList === null || imageList === void 0 ? void 0 : imageList.length) !== 5 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "drag-and-drop-container",
                ...getRootProps(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ...getInputProps()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "drag-and-drop-text-large",
                        children: i18n === null || i18n === void 0 ? void 0 : i18n.dragAndDrop
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "drag-and-drop-text-small",
                        children: i18n === null || i18n === void 0 ? void 0 : i18n.orText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "drag-and-drop-upload-btn",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            role: "button",
                            tabIndex: "-1",
                            className: buttonAnalyticsData ? "gbh-data-layer" : "",
                            "data-gbh-data-layer": buttonAnalyticsData || null,
                            type: "ghost",
                            label: i18n === null || i18n === void 0 ? void 0 : i18n.uploadFileButton,
                            disabled: (imageList === null || imageList === void 0 ? void 0 : imageList.length) === 5 && lib/* isMobile */.tq,
                            useDefaultClass: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "region",
                "aria-live": "polite",
                className: "aria-messages",
                children: status
            }),
            (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "upload-image-container__error-msg",
                children: errors[0]
            })
        ]
    });
};
/* harmony default export */ var v1_UploadImage = (UploadImage);

// EXTERNAL MODULE: ./public/icons/email.svg
var email = __webpack_require__(39306);
// EXTERNAL MODULE: ./public/icons/phone-icon.svg
var phone_icon = __webpack_require__(52324);
// EXTERNAL MODULE: ./src/components/core/Input/Input.jsx
var Input = __webpack_require__(27222);
// EXTERNAL MODULE: ./src/components/core/RadioButton/RadioButton.jsx
var RadioButton = __webpack_require__(94593);
// EXTERNAL MODULE: ./src/components/RegisterOnlineProduct/v1/RegisterOnlineHelper.js
var RegisterOnlineHelper = __webpack_require__(407);
;// CONCATENATED MODULE: ./components/ContactUs/v1/Form/ContactInfo.jsx















const ContactInfo = (props)=>{
    var ref;
    const [countries, setCountries] = (0,react.useState)([]);
    const { activeTab ="" , data ={} , labels ={} , setData =()=>{} , error ={} , i18n ={} , setError =()=>{} , onBlur =()=>{}  } = props;
    const { CREATE_ACCOUNT_TYPE: { HOME_OWNER ="" , TRADE_ACCOUNT =""  }  } = constants["default"];
    const HOME_OWNER_TAB = startCase_default()(HOME_OWNER);
    const TRADE_TAB = startCase_default()(TRADE_ACCOUNT);
    const isMobile = window.innerWidth <= 480;
    const { countryListPath , stateListPath  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const marketList = [
        "Residential",
        "Commercial"
    ];
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        setData({
            ...data,
            state: {}
        });
    }, [
        data === null || data === void 0 ? void 0 : data.country
    ]);
    (0,react.useEffect)(()=>{
        try {
            if (!isEmpty_default()(countryListPath) && !isEmpty_default()(stateListPath)) getLocations();
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }, [
        countryListPath,
        stateListPath
    ]);
    const getLocations = async ()=>{
        if (countryListPath && stateListPath) {
            var ref;
            const countryData = await dispatch((0,genericSlice/* getCountryList */.Jp)());
            const stateData = await dispatch((0,genericSlice/* getstateList */.lK)());
            const mapList = !isEmpty_default()(countryData === null || countryData === void 0 ? void 0 : countryData.payload) && !isEmpty_default()(stateData === null || stateData === void 0 ? void 0 : stateData.payload) && (0,helper/* mapStateToCountryHandler */.oFy)(countryData === null || countryData === void 0 ? void 0 : countryData.payload, stateData === null || stateData === void 0 ? void 0 : stateData.payload) || [];
            setCountries(mapList);
            const config = await (0,constants_config/* getConfig */.i)();
            var ref1;
            const countryCode = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.country) !== null && ref1 !== void 0 ? ref1 : "US";
            var ref2;
            setData({
                ...data,
                country: (ref2 = mapList.find((country)=>{
                    return (country === null || country === void 0 ? void 0 : country.code) === countryCode;
                })) !== null && ref2 !== void 0 ? ref2 : {}
            });
        }
    };
    const onInputChange = (e)=>{
        const { target: { value ="" , id =""  } = {}  } = e;
        const field = id === null || id === void 0 ? void 0 : id.split("-");
        setData({
            ...data,
            [field[2]]: value
        });
        setError((prevError)=>({
                ...prevError,
                [field[2]]: null
            }));
    };
    const onNameChange = async (e)=>{
        const { target: { value ="" , id =""  } = {}  } = e;
        const field = id === null || id === void 0 ? void 0 : id.split("-");
        if (value === "" || await (0,helper/* validateField */.OP$)("name", value)) {
            setData({
                ...data,
                [field[2]]: value
            });
            setError((prevError)=>({
                    ...prevError,
                    [field[2]]: null
                }));
        }
    };
    const changeCountry = (country)=>{
        setData({
            ...data,
            country: countries === null || countries === void 0 ? void 0 : countries.find((c)=>{
                return (c === null || c === void 0 ? void 0 : c.name) === country;
            })
        });
    };
    const radioKeyDown = (e)=>{
        const nextRadio = e.target.nextSibling;
        const previousRadio = e.target.previousSibling;
        if (e.key === "ArrowLeft" && previousRadio) {
            previousRadio.focus();
        } else if (e.key === "ArrowRight" && nextRadio) {
            nextRadio.focus();
        } else if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.target.click();
        }
    };
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container mb-40",
        children: [
            activeTab === TRADE_TAB && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-6 py-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                            id: "contact-user-market-residential",
                            name: "contact-user-market",
                            value: marketList[0],
                            checked: data.market === marketList[0] || data.market === "",
                            onClick: ()=>setData({
                                    ...data,
                                    market: marketList[0]
                                }),
                            onKeydown: radioKeyDown
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-6 py-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                            id: "contact-user-market-commercial",
                            name: "contact-user-market",
                            value: marketList[1],
                            checked: data.market === marketList[1],
                            onClick: ()=>setData({
                                    ...data,
                                    market: marketList[1]
                                }),
                            onKeydown: radioKeyDown
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-business",
                            type: "text",
                            value: data.company,
                            maxLength: 50,
                            placeholder: "".concat(i18n.businessName, "*"),
                            label: "".concat(i18n.businessName, "*"),
                            onChange: (e)=>{
                                const { value  } = e.target;
                                if ((0,helper/* validateField */.OP$)("businessName", value) || value === "") {
                                    setData({
                                        ...data,
                                        ["company"]: value
                                    });
                                }
                            },
                            showError: error.business,
                            errorMessage: error.business,
                            onBlur: ()=>props.onBlur("business")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pl-0 ".concat(isMobile ? "pr-0" : "pr-10"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-fname",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.fname,
                            maxLength: 40,
                            placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.fname, "*"),
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.fname, "*"),
                            onChange: onNameChange,
                            showError: error === null || error === void 0 ? void 0 : error.fname,
                            errorMessage: error === null || error === void 0 ? void 0 : error.fname,
                            onBlur: ()=>onBlur("fname")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pr-0 ".concat(isMobile ? "pl-0" : "pl-10"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-lname",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.lname,
                            maxLength: 40,
                            placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.lname, "*"),
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.lname, "*"),
                            onChange: onNameChange,
                            showError: error === null || error === void 0 ? void 0 : error.lname,
                            errorMessage: error === null || error === void 0 ? void 0 : error.lname,
                            onBlur: ()=>onBlur("lname")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-email",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.email,
                            maxLength: 60,
                            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: email/* default */.Z === null || email/* default */.Z === void 0 ? void 0 : email/* default.src */.Z.src,
                                alt: "",
                                "aria-hidden": "true"
                            }),
                            placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.email, "*"),
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.email, "*"),
                            onChange: onInputChange,
                            showError: error === null || error === void 0 ? void 0 : error.email,
                            errorMessage: error === null || error === void 0 ? void 0 : error.email,
                            onBlur: ()=>onBlur("email")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-cemail",
                            type: "text",
                            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: email/* default */.Z === null || email/* default */.Z === void 0 ? void 0 : email/* default.src */.Z.src,
                                alt: "",
                                "aria-hidden": "true"
                            }),
                            value: data === null || data === void 0 ? void 0 : data.cemail,
                            maxLength: 60,
                            placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.cemail, "*"),
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.cemail, "*"),
                            onChange: onInputChange,
                            showError: error === null || error === void 0 ? void 0 : error.cemail,
                            errorMessage: error === null || error === void 0 ? void 0 : error.cemail,
                            onBlur: ()=>onBlur("cemail")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pl-0 ".concat(isMobile ? "pr-0" : "pr-10"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-phone",
                            type: "text",
                            maxLength: 60,
                            placeholder: "".concat(activeTab === HOME_OWNER_TAB ? i18n === null || i18n === void 0 ? void 0 : i18n.phoneNumber : i18n === null || i18n === void 0 ? void 0 : i18n.businessPhone, "*"),
                            label: "".concat(activeTab === HOME_OWNER_TAB ? i18n === null || i18n === void 0 ? void 0 : i18n.phoneNumber : i18n === null || i18n === void 0 ? void 0 : i18n.businessPhone, "*"),
                            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: phone_icon/* default */.Z === null || phone_icon/* default */.Z === void 0 ? void 0 : phone_icon/* default.src */.Z.src,
                                alt: "",
                                "aria-hidden": "true"
                            }),
                            value: data === null || data === void 0 ? void 0 : data.phone,
                            onChange: (e)=>setData({
                                    ...data,
                                    phone: (0,RegisterOnlineHelper/* convertToPhoneNumber */["in"])(e.target.value)
                                }),
                            showError: error === null || error === void 0 ? void 0 : error.phone,
                            errorMessage: error === null || error === void 0 ? void 0 : error.phone,
                            onBlur: ()=>onBlur("phone")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pr-0 ".concat(isMobile ? "pl-0" : "pl-10"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-zipcode",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.zipcode,
                            maxLength: 7,
                            autoComplete: true,
                            placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.zipcode, "*"),
                            label: "".concat(labels && labels.zipCodeLabel ? labels.zipCodeLabel : i18n === null || i18n === void 0 ? void 0 : i18n.zipcode, "*"),
                            onChange: onInputChange,
                            showError: error === null || error === void 0 ? void 0 : error.zipcode,
                            errorMessage: error === null || error === void 0 ? void 0 : error.zipcode,
                            onBlur: ()=>onBlur("zipcode")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row mx-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12 col-sm-6 col-md-6 pl-0 ".concat(isMobile ? "pr-0" : "pr-10"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                        id: "contact-user-country",
                        data: countries.map((country)=>{
                            return country === null || country === void 0 ? void 0 : country.name;
                        }),
                        name: "country",
                        value: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.country) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : "",
                        label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.country),
                        onChange: changeCountry,
                        showError: error === null || error === void 0 ? void 0 : error.country,
                        errorMessage: error === null || error === void 0 ? void 0 : error.country
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Form_ContactInfo = (ContactInfo);

;// CONCATENATED MODULE: ./components/ContactUs/v1/Form/WithProfessional.jsx





const WithProfessional = (props)=>{
    const { i18n ={} , data ={} , setData =()=>{} , radioKeyDown =()=>{} , onBlur =()=>{} , error ={}  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "optional-form professional-group",
        role: "radiogroup",
        "aria-labelledby": "with-professional-radio",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "with-professional-radio",
                className: "question",
                children: i18n === null || i18n === void 0 ? void 0 : i18n.workingWithProfessional
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "radio-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "radio-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                id: "with-professional",
                                name: "with-professional",
                                value: i18n === null || i18n === void 0 ? void 0 : i18n.yes,
                                checked: data === null || data === void 0 ? void 0 : data.active,
                                onClick: ()=>setData({
                                        active: true
                                    }),
                                onKeydown: radioKeyDown
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                id: "without-professional",
                                name: "with-professional",
                                value: i18n === null || i18n === void 0 ? void 0 : i18n.no,
                                checked: !(data === null || data === void 0 ? void 0 : data.active),
                                onClick: ()=>setData({
                                        active: false
                                    }),
                                onKeydown: radioKeyDown
                            })
                        ]
                    }),
                    (data === null || data === void 0 ? void 0 : data.active) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "form-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                id: "kf-professional-name",
                                type: "text",
                                value: (data === null || data === void 0 ? void 0 : data.professionalName) || "",
                                maxLength: 50,
                                placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.contactName, "*"),
                                label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.contactName, "*"),
                                showError: error === null || error === void 0 ? void 0 : error.professionalName,
                                errorMessage: error === null || error === void 0 ? void 0 : error.professionalName,
                                onChange: async (e)=>{
                                    const { value  } = e.target;
                                    if (await (0,helper/* validateField */.OP$)("name", value) || value === "") {
                                        setData({
                                            ...data,
                                            professionalName: value
                                        });
                                    }
                                },
                                onBlur: ()=>onBlur("professionalName")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                id: "kf-professional-company",
                                type: "text",
                                value: (data === null || data === void 0 ? void 0 : data.company) || "",
                                maxLength: 50,
                                placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.companyName, "*"),
                                showError: error === null || error === void 0 ? void 0 : error.company,
                                errorMessage: error === null || error === void 0 ? void 0 : error.company,
                                label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.companyName, "*"),
                                onChange: async (e)=>{
                                    const { value  } = e.target;
                                    if (await (0,helper/* validateField */.OP$)("contactusCompanyName", value) || value === "") {
                                        setData({
                                            ...data,
                                            company: value
                                        });
                                    }
                                },
                                onBlur: ()=>onBlur("company")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Form_WithProfessional = (WithProfessional);

// EXTERNAL MODULE: ./public/icons/back-arrow.svg
var back_arrow = __webpack_require__(64821);
;// CONCATENATED MODULE: ./components/ContactUs/v1/ContactUsConfirmation.jsx







const ContactUsConfirmation = (props)=>{
    const { setSubmitSuccess =()=>{} , i18n ={} , continueShoppingUrl =""  } = props;
    const successMessageRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        var ref;
        successMessageRef === null || successMessageRef === void 0 ? void 0 : (ref = successMessageRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        window === null || window === void 0 ? void 0 : window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "kf-react-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "contact-us__success-message",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "back gbh-data-layer",
                    "data-gbh-data-layer": getEventInfo("back to contact us"),
                    onClick: ()=>setSubmitSuccess(false),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: back_arrow/* default */.Z === null || back_arrow/* default */.Z === void 0 ? void 0 : back_arrow/* default.src */.Z.src,
                            alt: "Back"
                        }),
                        i18n === null || i18n === void 0 ? void 0 : i18n.backToContactUs
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: successMessageRef,
                    id: "contact-us-success-message",
                    className: "message-content",
                    tabIndex: "0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "title",
                            children: i18n === null || i18n === void 0 ? void 0 : i18n.messageSent
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "details",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(i18n === null || i18n === void 0 ? void 0 : i18n.responseReceiveTime)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "primary",
                    size: "flexible",
                    label: i18n === null || i18n === void 0 ? void 0 : i18n.continueShopping,
                    to: continueShoppingUrl,
                    className: "gbh-data-layer contact-us__continue-shopping-btn",
                    "data-gbh-data-layer": getEventInfo("continue shopping", continueShoppingUrl),
                    useDefaultClass: true
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ContactUsConfirmation = ((0,lib/* withOrientationChange */.Qe)(ContactUsConfirmation));

// EXTERNAL MODULE: ./src/components/core/TextArea/index.module.scss
var index_module = __webpack_require__(52003);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(15740);
;// CONCATENATED MODULE: ./components/ContactUs/v1/ContactUsView/contactUsViewAnalytics.js
const contactUsViewAnalytics_getAnalyticsData = (activeTab, formError, submitSuccess, isForSubButton, formErrorFromServer, isSuccessStatus, selectedSupport, isProfessional, businessType)=>{
    const internalLinkType = isForSubButton ? "support:contact:submit" : "support:contact:navigation";
    const eventType = isForSubButton ? "submit" : "upload file";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "support:contact:form:".concat(activeTab === null || activeTab === void 0 ? void 0 : activeTab.toLowerCase(), ":").concat(eventType),
        eventMsg: isForSubButton ? formErrorFromServer ? formErrorFromServer : formError : "n/a",
        eventName: "support:contact:form:".concat(activeTab === null || activeTab === void 0 ? void 0 : activeTab.toLowerCase(), ":").concat(eventType),
        eventStatus: isForSubButton ? submitSuccess || isSuccessStatus ? "success" : "failure" : "n/a",
        eventType: "navigation",
        internalLinkName: eventType,
        internalLinkPosition: "contact us",
        internalLinkType,
        internalLinkURL: "n/a",
        internalLinkZoneName: "support:contact:form"
    };
    if (eventType === "submit") {
        eventInfo.selectTopicforHelp = "".concat(selectedSupport || "n/a");
        eventInfo.workingWithProfessional = (activeTab === null || activeTab === void 0 ? void 0 : activeTab.toLowerCase()) === "homeowner" ? isProfessional === true ? "yes" : "no" : "n/a";
        eventInfo.businessType = "".concat(businessType || "n/a");
    }
    return JSON.stringify(eventInfo);
};
const addFormAnalyticsData = function(activeTab, submitSuccess, formError, isSuccessStatus) {
    let selectedSupport = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, isProfessional = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, businessType = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = contactUsViewAnalytics_getAnalyticsData(activeTab, formError, submitSuccess, true, formError, isSuccessStatus, selectedSupport === null || selectedSupport === void 0 ? void 0 : selectedSupport.toLowerCase(), isProfessional, businessType === null || businessType === void 0 ? void 0 : businessType.toLowerCase());
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo: JSON.parse(eventInfo),
        page: page
    });
};
const getFooterEventInfo = function(type, link) {
    let clickInternalLinks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "true";
    return JSON.stringify({
        eventAction: "support:contact:form:footer:" + type,
        eventName: "support:contact:form:footer:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "contact us",
        internalLinkType: "support:contact:navigation",
        internalLinkZoneName: "support:contact:form:footer",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks
    });
};
const getRecaptchaAnalytics = {
    pageTitle: "support:contact",
    internalLinkPosition: "contact us",
    internalLinkType: "support:contact:navigation"
};

;// CONCATENATED MODULE: ./components/ContactUs/v1/ContactUsView/index.jsx


















const ContactUs = (props)=>{
    var ref;
    const [error, setError] = (0,react.useState)({});
    const [userData, setUserData] = (0,react.useState)({
        fname: "",
        lname: "",
        email: "",
        cemail: "",
        zipcode: "",
        country: {},
        phone: "",
        company: "",
        market: "Residential",
        professionalName: ""
    });
    const [homeOwnerData, setHomeOwnerData] = (0,react.useState)({
        fname: "",
        lname: "",
        email: "",
        cemail: "",
        zipcode: "",
        country: {},
        phone: "",
        company: "",
        professionalName: ""
    });
    const [professionalData, setProfessionalData] = (0,react.useState)({
        fname: "",
        lname: "",
        email: "",
        cemail: "",
        zipcode: "",
        country: {},
        phone: "",
        company: "",
        market: "Residential"
    });
    const { CREATE_ACCOUNT_TYPE: { HOME_OWNER ="" , TRADE_ACCOUNT =""  }  } = constants["default"];
    const HOME_OWNER_TAB = startCase_default()(HOME_OWNER);
    const TRADE_TAB = startCase_default()(TRADE_ACCOUNT);
    (0,react.useEffect)(()=>{
        if (activeTab === HOME_OWNER_TAB) {
            setHomeOwnerData(userData);
        } else {
            setProfessionalData(userData);
        }
    }, [
        userData
    ]);
    const [professional, setProfessional] = (0,react.useState)({
        active: true,
        company: "",
        professionalName: ""
    });
    const [requestMessage, setRequestMessage] = (0,react.useState)("");
    const [imageFiles, setImageFiles] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(false);
    const [formError, setFormError] = (0,react.useState)("");
    const [count, setCount] = (0,react.useState)(0);
    const [selectedSupport, setSelectedSupport] = (0,react.useState)("");
    const { i18n ={} , submitSuccess =false , setActiveTab =()=>{} , activeTab ="" , sourceKey ="" , handleSubmitMsg =()=>{} , showToaster =()=>{} , authorData ={} , legalPages ={} , continueShoppingUrl =""  } = props;
    const contactInfoLabels = {
        zipCodeLabel: authorData === null || authorData === void 0 ? void 0 : authorData.zipCodeLabel,
        stateLabel: authorData === null || authorData === void 0 ? void 0 : authorData.stateLabel
    };
    const validateExist = async (field)=>{
        switch(field){
            case "fname":
            case "lname":
                var ref;
                if (!((ref = userData[field]) === null || ref === void 0 ? void 0 : ref.trim()) || !await (0,helper/* validateField */.OP$)("name", userData[field])) {
                    return field === "fname" ? i18n === null || i18n === void 0 ? void 0 : i18n.fnameError : i18n === null || i18n === void 0 ? void 0 : i18n.lnameError;
                }
                break;
            case "email":
                if (!userData[field]) return i18n === null || i18n === void 0 ? void 0 : i18n.noEmailError;
                else if (!await (0,helper/* validateField */.OP$)("email", userData[field])) return i18n === null || i18n === void 0 ? void 0 : i18n.validEmail;
                break;
            case "business":
                if (!(userData === null || userData === void 0 ? void 0 : userData.company)) return i18n === null || i18n === void 0 ? void 0 : i18n.noCompanyError;
                break;
            case "cemail":
                if (!userData[field]) return i18n === null || i18n === void 0 ? void 0 : i18n.noEmailError;
                else if (!await (0,helper/* validateField */.OP$)("email", userData[field])) return i18n === null || i18n === void 0 ? void 0 : i18n.validEmail;
                else if ((userData === null || userData === void 0 ? void 0 : userData.email) !== (userData === null || userData === void 0 ? void 0 : userData.cemail)) return i18n === null || i18n === void 0 ? void 0 : i18n.emailMatchError;
                break;
            case "phone":
                if (!(userData === null || userData === void 0 ? void 0 : userData.phone)) return i18n === null || i18n === void 0 ? void 0 : i18n.noPhoneError;
                else if (!(0,helper/* validatePhone */.a$Q)(userData === null || userData === void 0 ? void 0 : userData.phone)) return i18n === null || i18n === void 0 ? void 0 : i18n.validPhone;
                break;
            case "zipcode":
                if (!userData.zipcode.trim()) return i18n.zipcodeError;
                else if (userData.zipcode.length < 5) return i18n.validZipcode;
                break;
            case "company":
                if (!(professional === null || professional === void 0 ? void 0 : professional.company)) return i18n === null || i18n === void 0 ? void 0 : i18n.noCompanyError;
                break;
            case "professionalName":
                if (!(professional === null || professional === void 0 ? void 0 : professional.professionalName)) return i18n === null || i18n === void 0 ? void 0 : i18n.contactNameError;
                break;
            default:
                return;
        }
    };
    const onBlurError = async (field)=>{
        setError({
            ...error,
            [field]: await validateExist(field)
        });
    };
    const radioKeyDown = (e)=>{
        const { target: radioTarget = {} , key: radioKey = ""  } = e;
        const { nextSibling , previousSibling  } = radioTarget;
        const nextRadio = nextSibling;
        const previousRadio = previousSibling;
        if (radioKey === "ArrowLeft" && previousRadio) {
            previousRadio === null || previousRadio === void 0 ? void 0 : previousRadio.focus();
        } else if (radioKey === "ArrowRight" && nextRadio) {
            nextRadio === null || nextRadio === void 0 ? void 0 : nextRadio.focus();
        } else if (radioKey === "Enter" || radioKey === " ") {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            radioTarget === null || radioTarget === void 0 ? void 0 : radioTarget.click();
        }
    };
    const getErrorList = async ()=>{
        const errorList = {
            fname: await validateExist("fname"),
            lname: await validateExist("lname"),
            email: await validateExist("email"),
            cemail: await validateExist("cemail"),
            zipcode: await validateExist("zipcode"),
            phone: await validateExist("phone"),
            helpTopic: await validateExist("helpTopic")
        };
        if (activeTab === TRADE_TAB) {
            errorList.business = await validateExist("business");
        } else if (activeTab === HOME_OWNER_TAB && (professional === null || professional === void 0 ? void 0 : professional.active)) {
            errorList.professionalName = await validateExist("professionalName");
            errorList.company = await validateExist("company");
        }
        return errorList;
    };
    const onSubmit = async ()=>{
        var ref;
        setLoading(true);
        const errorDataList = [];
        const errorList = await getErrorList();
        const imageLinks = imageFiles === null || imageFiles === void 0 ? void 0 : imageFiles.map((image)=>{
            return {
                link: image === null || image === void 0 ? void 0 : image.link,
                comment: image === null || image === void 0 ? void 0 : image.comment
            };
        });
        setError(errorList);
        if (errorList === null || errorList === void 0 ? void 0 : errorList.fname) {
            errorDataList.push("contact-user-fname");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.lname) {
            errorDataList.push("contact-user-lname");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.email) {
            errorDataList.push("contact-user-email");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.cemail) {
            errorDataList.push("contact-user-cemail");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.zipcode) {
            errorDataList.push("contact-user-zipcode");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.phone) {
            errorDataList.push("contact-user-phone");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.helpTopic) {
            errorDataList.push("type-of-support");
        }
        if (activeTab === HOME_OWNER_TAB && (professional === null || professional === void 0 ? void 0 : professional.active)) {
            if (errorList === null || errorList === void 0 ? void 0 : errorList.professionalName) {
                errorDataList.push("kf-professional-name");
            } else if (errorList === null || errorList === void 0 ? void 0 : errorList.company) {
                errorDataList.push("contact-user-company");
            }
        }
        if (activeTab === TRADE_TAB) {
            if (errorList === null || errorList === void 0 ? void 0 : errorList.business) {
                errorDataList.push("contact-user-business");
            }
        }
        errorDataList.forEach((item, i)=>{
            var ref;
            if (i === 0) (ref = document.getElementById("".concat(item))) === null || ref === void 0 ? void 0 : ref.focus();
        });
        const isInvalid = (ref = Object.values(errorList)) === null || ref === void 0 ? void 0 : ref.find((el)=>el);
        if (!isInvalid) {
            const { fname , lname , email , zipcode , country , phone , company , market  } = userData;
            const body = {
                FirstName: fname,
                LastName: lname,
                Email: email,
                PostalCode: zipcode,
                Country: country === null || country === void 0 ? void 0 : country.code,
                Phone: phone,
                AttachmentLinks: imageLinks,
                CustomerType: activeTab,
                InteractionType: "ContactUs",
                DescribeYourRequest: requestMessage,
                TopicSelected: selectedSupport,
                SourceKey: [
                    {
                        Type: sourceKey,
                        Value: "".concat(Math.floor(1000 + Math.random() * 9000)),
                        CreateDate: new Date().toISOString(),
                        UpdateDate: new Date().toISOString()
                    }
                ],
                Website: sourceKey
            };
            if (activeTab === TRADE_TAB) {
                body["Company"] = company;
                body["Market"] = market;
            }
            if (activeTab === HOME_OWNER_TAB && (professional === null || professional === void 0 ? void 0 : professional.active)) {
                body["IsProfessional"] = professional === null || professional === void 0 ? void 0 : professional.active;
                if (professional === null || professional === void 0 ? void 0 : professional.active) {
                    body["OtherProfessionalCompany"] = professional === null || professional === void 0 ? void 0 : professional.company;
                    body["ProfessionalName"] = professional === null || professional === void 0 ? void 0 : professional.professionalName;
                }
            }
            (0,helper/* sanitizeObject */.O0b)(body);
            (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
                if (res === null || res === void 0 ? void 0 : res.success) {
                    api/* apim.post */.TH.post(constants.CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT, body).then(()=>{
                        handleSubmitMsg(true);
                        addFormAnalyticsData(activeTab, submitSuccess, "", true, body === null || body === void 0 ? void 0 : body.TopicSelected, body === null || body === void 0 ? void 0 : body.IsProfessional, body === null || body === void 0 ? void 0 : body.Market);
                        setTimeout(()=>{
                            setActiveTab(HOME_OWNER_TAB);
                        }, 0);
                    }).catch((err)=>{
                        setFormError(i18n === null || i18n === void 0 ? void 0 : i18n.serverError);
                        addFormAnalyticsData(activeTab, submitSuccess, i18n === null || i18n === void 0 ? void 0 : i18n.serverError, false, body === null || body === void 0 ? void 0 : body.TopicSelected, body === null || body === void 0 ? void 0 : body.IsProfessional, body === null || body === void 0 ? void 0 : body.Market);
                        setLoading(false);
                        // eslint-disable-next-line no-console
                        console.log(err);
                    });
                } else {
                    setLoading(false);
                    addFormAnalyticsData(activeTab, submitSuccess, i18n === null || i18n === void 0 ? void 0 : i18n.genError, false, body === null || body === void 0 ? void 0 : body.TopicSelected, body === null || body === void 0 ? void 0 : body.IsProfessional, body === null || body === void 0 ? void 0 : body.Market);
                    showToaster(i18n === null || i18n === void 0 ? void 0 : i18n.genError);
                }
            });
        } else {
            setLoading(false);
            const allErrors = [];
            for(const key in errorList){
                if (errorList[key]) {
                    var ref1;
                    allErrors === null || allErrors === void 0 ? void 0 : allErrors.push((ref1 = errorList[key]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase());
                }
            }
            addFormAnalyticsData(activeTab, submitSuccess, allErrors === null || allErrors === void 0 ? void 0 : allErrors.join("|"), false, selectedSupport, activeTab === HOME_OWNER_TAB ? professional === null || professional === void 0 ? void 0 : professional.active : null, activeTab === TRADE_TAB ? userData === null || userData === void 0 ? void 0 : userData.market : null);
        }
    };
    const checkDisabled = (userdata)=>{
        var ref, ref1, ref2;
        if ((userdata === null || userdata === void 0 ? void 0 : (ref = userdata.fname) === null || ref === void 0 ? void 0 : ref.trim()) && (userdata === null || userdata === void 0 ? void 0 : (ref1 = userdata.lname) === null || ref1 === void 0 ? void 0 : ref1.trim()) && (userdata === null || userdata === void 0 ? void 0 : (ref2 = userdata.email) === null || ref2 === void 0 ? void 0 : ref2.trim()) && (userdata === null || userdata === void 0 ? void 0 : userdata.country) && (userdata === null || userdata === void 0 ? void 0 : userdata.phone) && selectedSupport) return false;
        return true;
    };
    const changeSupport = (support)=>{
        setSelectedSupport(support);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: !submitSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "kf-react-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "contact-us-main",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "question",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.contactInformation
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "required-fields",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.requiredInfoText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FormTabs, {
                        label: [
                            HOME_OWNER_TAB,
                            TRADE_TAB
                        ],
                        customClass: "gbh-data-layer",
                        analyticsData: '{"eventAction":"support:contact:form:{?}","eventName":"support:contact:form:{?}","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"{?}","internalLinkPosition":"contact us","internalLinkType":"support:contact:contact information","internalLinkZoneName":"support:contact:form","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                        activeTab: activeTab,
                        changeActive: (l)=>{
                            setActiveTab(l);
                            setUserData(l === HOME_OWNER_TAB ? homeOwnerData : professionalData);
                            setError({});
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_ContactInfo, {
                        activeTab: activeTab,
                        data: userData,
                        labels: contactInfoLabels,
                        setData: setUserData,
                        error: error,
                        i18n: i18n,
                        onBlur: onBlurError,
                        setError: setError
                    }, activeTab),
                    activeTab === HOME_OWNER_TAB && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_WithProfessional, {
                        i18n: i18n,
                        data: professional,
                        setData: setProfessional,
                        radioKeyDown: radioKeyDown,
                        error: error,
                        onBlur: onBlurError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "optional-form",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "contactus-request-message",
                                className: "question",
                                children: i18n.selectTypeOfSupport
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                id: "type-of-support",
                                data: props === null || props === void 0 ? void 0 : (ref = props.helpTopic) === null || ref === void 0 ? void 0 : ref.map((topic)=>topic),
                                name: "selectedSupport",
                                value: selectedSupport !== null && selectedSupport !== void 0 ? selectedSupport : "",
                                label: "".concat(i18n.howCanWeHelp, "*"),
                                onChange: changeSupport,
                                onBlur: onBlurError,
                                showError: error.selectedSupport,
                                errorMessage: error.selectedSupport
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "contactus-enquiry-text",
                                className: "question",
                                children: [
                                    i18n.requestDetailHeading,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "description",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.requestDetail
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (index_module_default()).wrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-wrapper textarea__wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                            className: "textarea-message",
                                            id: "requestMessage",
                                            "aria-labelledby": "contactus-request-message",
                                            value: requestMessage,
                                            placeholder: "Message",
                                            onChange: async (e)=>{
                                                const { value  } = e.target;
                                                if (await (0,helper/* validateField */.OP$)("contactusMessage", value) || value === "") {
                                                    setCount(value === null || value === void 0 ? void 0 : value.length);
                                                    setRequestMessage(value);
                                                }
                                            },
                                            maxLength: "500"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            "aria-hidden": "true",
                                            className: "textare-label-message",
                                            children: i18n === null || i18n === void 0 ? void 0 : i18n.messageLabel
                                        }),
                                        count !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "contact-us-count",
                                            children: [
                                                count,
                                                "/500"
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "optional-form",
                        id: "contactus-upload-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "contactus-upload-text",
                                className: "question",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.uploadPhoto
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "description",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.uploadCountLimit
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "upload-notes",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.uploadFileTypes
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.uploadFileExtn
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "upload-notes",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.uploadSizeLimit
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.uploadMBLimit
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_UploadImage, {
                                imageList: imageFiles,
                                updateList: setImageFiles,
                                i18n: i18n,
                                activeTab: activeTab,
                                buttonAnalyticsData: contactUsViewAnalytics_getAnalyticsData(activeTab, formError, submitSuccess, false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "contact-us-footer",
                        children: [
                            formError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "contact-us-footer__error-msg",
                                children: formError
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                role: "button",
                                id: "submit-contact-form-button",
                                disabled: checkDisabled(userData),
                                onClick: onSubmit,
                                type: "black",
                                label: i18n === null || i18n === void 0 ? void 0 : i18n.submitButton,
                                flexible: true,
                                loading: loading,
                                useDefaultClass: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {
                                getAnalyticsData: getRecaptchaAnalytics
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "contact-us__policies",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: legalPages === null || legalPages === void 0 ? void 0 : legalPages.privacyPolicy,
                                        "data-gbh-data-layer": getFooterEventInfo("privacy policy", legalPages === null || legalPages === void 0 ? void 0 : legalPages.privacyPolicy),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: (e)=>{
                                            return (0,helper/* getSiteWideModal */.Ure)(e, legalPages === null || legalPages === void 0 ? void 0 : legalPages.privacyPolicy);
                                        },
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.privacyPolicy
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: legalPages === null || legalPages === void 0 ? void 0 : legalPages.subjectAccessRequest,
                                        "data-gbh-data-layer": getFooterEventInfo("subject access request", legalPages === null || legalPages === void 0 ? void 0 : legalPages.subjectAccessRequest, "false"),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: (e)=>{
                                            return (0,helper/* getSiteWideModal */.Ure)(e, legalPages === null || legalPages === void 0 ? void 0 : legalPages.subjectAccessRequest);
                                        },
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.subjectAccessRequest
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: legalPages === null || legalPages === void 0 ? void 0 : legalPages.termsOfService,
                                        "data-gbh-data-layer": getFooterEventInfo("terms of service", legalPages === null || legalPages === void 0 ? void 0 : legalPages.termsOfService),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: (e)=>{
                                            return (0,helper/* getSiteWideModal */.Ure)(e, legalPages === null || legalPages === void 0 ? void 0 : legalPages.termsOfService);
                                        },
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.termsOfService
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "contact-us__success-message-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ContactUsConfirmation, {
                i18n: i18n,
                setSubmitSuccess: handleSubmitMsg,
                continueShoppingUrl: continueShoppingUrl
            })
        })
    });
};
/* harmony default export */ var ContactUsView = ((0,lib/* withOrientationChange */.Qe)(ContactUs));

;// CONCATENATED MODULE: ./components/ContactUs/v1/ContactUs.jsx












const ContactUs_ContactUs = (props)=>{
    const { data: componentProp  } = props;
    const { type: sourceKeyType = "" , continueShoppingUrl =""  } = componentProp;
    const { CREATE_ACCOUNT_TYPE: { HOME_OWNER =""  }  } = constants["default"];
    const [activeTab, setActiveTabVal] = (0,react.useState)(startCase_default()(HOME_OWNER));
    const [helpTopic, setHelpTopic] = (0,react.useState)([]);
    const [submitSuccess, setSubmitSuccess] = (0,react.useState)(false);
    const [homePagePath, setHomePagePath] = (0,react.useState)();
    const [legalPageLinks, setLegalPageLinks] = (0,react.useState)();
    const [continueShoppingUrlData, setContinueShoppingUrlData] = (0,react.useState)("");
    const i18n = i18n_useContactUsi18n(componentProp);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* getGenericListPath */.Ln)());
    }, []);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const homePagePath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.homepageUrl", "/"));
            const legalPageLinks = get_default()(config, "legalPageData.map", {});
            setHomePagePath(homePagePath);
            setLegalPageLinks(legalPageLinks);
            setContinueShoppingUrlData(await (0,helper/* getShortenedUrl */.Ppy)(continueShoppingUrl || ""));
        });
        if (isEmpty_default()(helpTopic)) getListItem();
    });
    const handleSubmit = (status)=>{
        const container = document.getElementById("aem-contact-us-container");
        status ? container === null || container === void 0 ? void 0 : container.classList.add("d-none") : container === null || container === void 0 ? void 0 : container.classList.remove("d-none");
        setSubmitSuccess(status);
    };
    const getListItem = async ()=>{
        var ref, ref1;
        const { payload: commonList  } = await dispatch((0,genericSlice/* getCommonList */.m8)());
        setHelpTopic((ref = commonList === null || commonList === void 0 ? void 0 : commonList.find((el)=>{
            return (el === null || el === void 0 ? void 0 : el.text) === "helpTopic";
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.split(","));
    };
    const setActiveTab = (t)=>{
        setActiveTabVal(t);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsView, {
        i18n: i18n,
        helpTopic: helpTopic,
        sourceKey: sourceKeyType,
        continueShoppingUrl: continueShoppingUrlData,
        showToaster: (msg)=>(0,genericSlice/* showToast */.CF)({
                message: msg,
                isVisible: true
            }),
        homePagePath: homePagePath,
        submitSuccess: submitSuccess,
        handleSubmitMsg: handleSubmit,
        legalPages: legalPageLinks,
        setActiveTab: setActiveTab,
        activeTab: activeTab,
        authorData: componentProp
    }, submitSuccess);
};
/* harmony default export */ var v1_ContactUs = (ContactUs_ContactUs);


/***/ }),

/***/ 79491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const KnowledgeArticleFiller = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "kf-react-plp-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "kf-page-title",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "width-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "kf-page-title__title shimmer-loading__title shimmer mb-20"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "kf-page-title__title shimmer-loading__title shimmer"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "kf-page-title__separator"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "width-250",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "shimmer-loading__para shimmer "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "shimmer-loading__para shimmer "
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "kf-page-title__total",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "shimmer-loading__para shimmer width-full"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "kf-react-plp-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "kf-page-title",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "width-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "kf-page-title__title shimmer-loading__title shimmer mb-20"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "kf-page-title__title shimmer-loading__title shimmer"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "kf-page-title__separator"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "width-250",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "shimmer-loading__para shimmer "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "shimmer-loading__para shimmer "
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "kf-page-title__total",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "shimmer-loading__para shimmer width-full"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "kf-react-plp-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "kf-page-title",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "width-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "kf-page-title__title shimmer-loading__title shimmer mb-20"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "kf-page-title__title shimmer-loading__title shimmer"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "kf-page-title__separator"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "width-250",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "shimmer-loading__para shimmer "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "shimmer-loading__para shimmer "
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "kf-page-title__total",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "shimmer-loading__para shimmer width-full"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (KnowledgeArticleFiller);


/***/ }),

/***/ 407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P0": function() { return /* binding */ getDDMMYYYYDate; },
/* harmony export */   "YU": function() { return /* binding */ submitRegistrationGenericError; },
/* harmony export */   "in": function() { return /* binding */ convertToPhoneNumber; },
/* harmony export */   "pD": function() { return /* binding */ getCountryName; },
/* harmony export */   "qs": function() { return /* binding */ getStateName; }
/* harmony export */ });
/* harmony import */ var _components_RegisterOnlineProduct_v1_RegisterOnlineProductAnalytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38327);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27514);


const submitRegistrationGenericError = (productDetails, errorMsg)=>{
    const isShowEvent = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isShowAnalyticsEventLoaded */ .xJ2)();
    if (!isShowEvent) {
        (0,_components_RegisterOnlineProduct_v1_RegisterOnlineProductAnalytics__WEBPACK_IMPORTED_MODULE_0__/* .addReviewRegistrationAnalytics */ .VS)("cmp:click", "failure", productDetails, errorMsg);
    }
};
const convertToPhoneNumber = (text)=>{
    try {
        if (text) {
            const value = text;
            const x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            const suffix = x[3] ? "-" + x[3] : "";
            return !x[2] ? "(" + x[1] : "(" + x[1] + ") " + x[2] + suffix;
        } else {
            return;
        }
    } catch (error) {
        console.error(error);
    }
};
const getStateName = (stateVal, countryVal, data)=>{
    var ref, ref1;
    let country = {};
    if (data.find((obj)=>obj.name === countryVal)) {
        country = data.find((obj)=>obj.name === countryVal);
    } else {
        var ref2;
        country = (ref2 = data.find((obj)=>obj.code === countryVal)) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>obj.name === stateVal)) return stateVal;
    var ref3;
    const state = (ref3 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>obj.code === stateVal)) !== null && ref3 !== void 0 ? ref3 : {};
    var _name;
    return (_name = state.name) !== null && _name !== void 0 ? _name : "";
};
const getCountryName = (countryVal, data)=>{
    if (data.find((obj)=>obj.name === countryVal)) return countryVal;
    var ref;
    const country = (ref = data.find((obj)=>obj.code === countryVal)) !== null && ref !== void 0 ? ref : {};
    var _name;
    return (_name = country.name) !== null && _name !== void 0 ? _name : "";
};
const getDDMMYYYYDate = (date)=>{
    const todayDate = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
    return todayDate;
};



/***/ }),

/***/ 38327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fi": function() { return /* binding */ addReviewRegistrationEventInfo; },
/* harmony export */   "Ki": function() { return /* binding */ selectProdcutEdit; },
/* harmony export */   "TP": function() { return /* binding */ getCheckboxAnalyticsdata; },
/* harmony export */   "VS": function() { return /* binding */ addReviewRegistrationAnalytics; },
/* harmony export */   "jb": function() { return /* binding */ personalInfoEdit; },
/* harmony export */   "m5": function() { return /* binding */ getSelectAllAnalytics; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; },
/* harmony export */   "y": function() { return /* binding */ getReviewProductsBackToMyProductsAnalytics; },
/* harmony export */   "zm": function() { return /* binding */ addRegisterOnlineProductsAnalytics; }
/* harmony export */ });
const addReviewRegistrationAnalytics = (action, status, productData, message)=>{
    const eventInfo = {
        eventAction: "my account:register online kohler products:review and register:submit registration",
        eventName: "my account:register online kohler products:review and register:submit registration",
        eventType: "navigation",
        eventMsg: message || "n/a",
        eventStatus: status || "n/a",
        internalLinkName: "submit registration",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:review and register",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const ProductInfo = [];
    productData === null || productData === void 0 ? void 0 : productData.map((data)=>{
        const obj = {
            productBrand: data.brandName || "n/a",
            productCategory: data.category || "n/a",
            productColor: data.colorValue || "n/a",
            productID: data.customerFacingSKU || "n/a",
            description: data.descriptio || "n/a",
            imgSrc: data.imgSrc || "n/a",
            orderNo: data.orderNo || "n/a",
            productName: data.productName || "n/a",
            purchaseDate: data.purchased || "n/a",
            skuid: data.skuid || "n/a",
            slug: data.slug || "n/a",
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            productCoupondiscount: "n/a",
            productPartnerBuyNow: "n/a",
            pdpType: "regular finished goods",
            productFindingMethod: "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: ProductInfo
    });
};
const getReviewProductsBackToMyProductsAnalytics = (isSuccess, myProductsPath)=>{
    const pageName = isSuccess ? "thank you for registering the products" : "top navigation";
    return JSON.stringify({
        eventAction: "my account:register online kohler products:".concat(pageName, ":back to my products"),
        eventName: "my account:register online kohler products:".concat(pageName, ":back to my products"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "back to my products",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:".concat(pageName),
        internalLinkURL: (myProductsPath.indexOf("http") === -1 ? window.location.origin : "") + myProductsPath,
        clickInternalLinks: "true"
    });
};
const personalInfoEdit = JSON.stringify({
    eventAction: "my account:register online kohler products:personal information:edit",
    eventName: "my account:register online kohler products:personal information:edit",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:register online kohler products:personal information",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const selectProdcutEdit = JSON.stringify({
    eventAction: "my account:register online kohler products:select the products you'd like to register:edit",
    eventName: "my account:register online kohler products:select the products you'd like to register:edit",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:register online kohler products:select the products you'd like to register",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const addRegisterOnlineProductsAnalytics = function(action, status, productData, message) {
    let eventText = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "personal information";
    const eventInfo = {
        eventAction: "my account:register online kohler products:".concat(eventText, ":next step"),
        eventName: "my account:register online kohler products:".concat(eventText, ":next step"),
        eventType: "navigation",
        eventMsg: message || "n/a",
        eventStatus: status,
        internalLinkName: "next step",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:".concat(eventText),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const ProductInfo = [];
    productData === null || productData === void 0 ? void 0 : productData.forEach((data)=>{
        const obj = {
            productBrand: data.brandName,
            productCategory: data.category || "n/a",
            productColor: data.colorValue || "n/a",
            productID: data.customerFacingSKU || "n/a",
            description: data.descriptio || "n/a",
            imgSrc: data.imgSrc || "n/a",
            orderNo: data.orderNo || "n/a",
            productName: data.productName || "n/a",
            purchaseDate: data.purchased || "n/a",
            skuid: data.skuid || "n/a",
            slug: data.slug || "n/a",
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            productCoupondiscount: "n/a",
            productPartnerBuyNow: "n/a",
            pdpType: "regular finished goods",
            productFindingMethod: "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: ProductInfo
    });
};
const getCheckboxAnalyticsdata = (isChecked)=>{
    const isCheckedOrUnchecked = isChecked ? "unchecked" : "checked";
    return JSON.stringify({
        eventAction: "my account:register online kohler products:select the products you'd like to register:register:".concat(isCheckedOrUnchecked),
        eventName: "my account:register online kohler products:select the products you'd like to register:register:".concat(isCheckedOrUnchecked),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "register:".concat(isCheckedOrUnchecked),
        internalLinkPosition: "register products",
        internalLinkType: "my account:checkbox",
        internalLinkZoneName: "my account:register online kohler products:select the products you'd like to register",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const getSelectAllAnalytics = (productData, data)=>{
    const isSelectOrUnselectAll = productData.length === (data === null || data === void 0 ? void 0 : data.length) ? "unselect all" : "select all";
    return JSON.stringify({
        eventAction: "my account:register online kohler products:select the products you'd like to register:".concat(isSelectOrUnselectAll),
        eventName: "my account:register online kohler products:select the products you'd like to register:".concat(isSelectOrUnselectAll),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(isSelectOrUnselectAll),
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:select the products you'd like to register",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const getEventInfo = (linkUrl, isForthankYOu)=>{
    const type = isForthankYOu ? "thank you for registering the products" : "product registration summary";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:register online kohler products:".concat(type, ":review products"),
        eventName: "my account:register online kohler products:".concat(type, ":review products"),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "review products",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkURL: (linkUrl.indexOf("http") === -1 ? window.location.origin : "") + linkUrl,
        internalLinkZoneName: "my account:register online kohler products:".concat(type)
    });
};
// step reviewInformation
const addReviewRegistrationEventInfo = (type, linkUrl)=>{
    const linkFor = type === null || type === void 0 ? void 0 : type.toLowerCase();
    return {
        eventAction: "my account:register online kohler products:review and register:".concat(linkFor),
        eventName: "my account:register online kohler products:review and register:".concat(linkFor),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: linkFor,
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:review and register",
        internalLinkURL: linkUrl,
        clickInternalLinks: "false"
    };
};



/***/ }),

/***/ 14629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47956);
/* harmony import */ var _components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8618);
/* harmony import */ var _components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const SelectDropdown = (props)=>{
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [opened, setOpened] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [filteredData, setFilteredData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    let isFocused = false;
    const dropDownClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        "select-dropdown": true,
        "dropdown--open": showList
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showList) {
            setOpened(true);
        } else if (!showList && opened && props.onClose) {
            props.onClose();
            setOpened(false);
        }
        const targetEelement = (e)=>{
            if (showList && document.getElementById(props.id) && !document.getElementById(props.id).contains(e.target)) {
                setShowList(false);
            }
        };
        document.addEventListener("click", targetEelement);
        return ()=>{
            document.removeEventListener("click", targetEelement);
        };
    }, [
        showList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setFilteredData(props.data);
    }, [
        props.data
    ]);
    const handleSelect = (value)=>{
        props.onChange(value);
        setShowList(false);
    };
    const handleMouseDownEvent = ()=>{
        isFocused = true;
        setShowList(!showList);
    };
    const handleBlurEvent = (e)=>{
        if (e instanceof MouseEvent) {
            isFocused;
            setShowList(false);
        }
        if (typeof props.onBlur === "function") {
            props.onBlur();
        }
    };
    const toggleList = ()=>{
        if (showList) {
            setShowList(false);
            document.getElementById(props.id).focus();
        } else {
            var ref;
            setShowList(true);
            (ref = document.getElementById("".concat(props.id, "-list"))) === null || ref === void 0 ? void 0 : ref.childNodes[0].focus();
        }
    };
    const btnKeyDown = (e)=>{
        const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_3__["default"];
        switch(e.keyCode){
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                e.preventDefault();
                toggleList();
                break;
            default:
                break;
        }
    };
    const handleKeyDown = (i, e)=>{
        const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_3__["default"];
        const ele = document.getElementById("".concat(props.id, "-list")).childNodes;
        switch(e.keyCode){
            case KEYCODE.ESC:
                toggleList();
                break;
            case KEYCODE.UP:
                if (i > 0) ele[i - 1].focus();
                break;
            case KEYCODE.DOWN:
                if (i < ele.length - 1) ele[i + 1].focus();
                break;
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                ele[i].click();
                document.getElementById(props.id).focus();
                break;
            default:
                break;
        }
    };
    const { customClass , id , tabIndex , label , ariaLabel , ariaRequired , value , ariaStateText , data , showError , errorMessage  } = props;
    const filterCityNames = (e)=>{
        var ref;
        const key = e === null || e === void 0 ? void 0 : (ref = e.key) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        if ((key === null || key === void 0 ? void 0 : key.length) === 1 && (key === null || key === void 0 ? void 0 : key.match(_constants_index__WEBPACK_IMPORTED_MODULE_3__["default"].REGEX_CONTAINS_LETTER))) {
            const filtered = data === null || data === void 0 ? void 0 : data.filter((item)=>{
                return item === null || item === void 0 ? void 0 : item.toLowerCase().startsWith(key);
            });
            setFilteredData(filtered !== null && filtered !== void 0 ? filtered : data);
        } else if (key === "backspace") {
            setFilteredData(data);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            onClick: handleMouseDownEvent,
            onBlur: handleBlurEvent,
            className: "".concat(dropDownClass, " ").concat(customClass !== null && customClass !== void 0 ? customClass : ""),
            onKeyDown: (e)=>filterCityNames(e),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: id,
                    className: "select-dropdown__field ".concat(showError ? "--with-error" : ""),
                    onKeyDown: btnKeyDown,
                    tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0,
                    role: "combobox",
                    "aria-controls": "dropdown-listbox",
                    "aria-expanded": showList,
                    "aria-haspopup": "true",
                    "aria-label": label ? label.replace(/\*/g, "") : ariaLabel ? ariaLabel.replace(/\*/g, "") : "",
                    "aria-required": (ariaRequired !== null && ariaRequired !== void 0 ? ariaRequired : label.indexOf("*") > 0) ? true : false,
                    "aria-describedby": "".concat(id, "-selected"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "select-dropdown__display",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    "aria-hidden": true,
                                    className: "select-dropdown__placeholder ".concat(value ? "--label" : ""),
                                    children: label
                                }),
                                value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    id: "".concat(id, "-selected"),
                                    className: "select-dropdown__value",
                                    children: value
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "select-dropdown__icon ".concat(showList ? "--open" : ""),
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/icons/down-icon.svg",
                                alt: "open-icon"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    id: "".concat(id, "-list"),
                    className: "select-dropdown__dropdown",
                    role: "listbox",
                    tabIndex: "-1",
                    "aria-expanded": "true",
                    "data-testid": "select-dropdown",
                    children: [
                        !ariaStateText && (filteredData === null || filteredData === void 0 ? void 0 : filteredData.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "select-dropdown__list-item ".concat(item === value && "selected-item"),
                                "aria-selected": item === value,
                                role: "option",
                                tabIndex: "-1",
                                onClick: ()=>handleSelect(item),
                                onKeyDown: (e)=>handleKeyDown(i, e),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "select-dropdown__list-value",
                                    children: item
                                })
                            }, i))),
                        ariaStateText && (filteredData === null || filteredData === void 0 ? void 0 : filteredData.map((item, i)=>{
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "select-dropdown__list-item ".concat(item.code === value && "selected-item"),
                                "aria-selected": item === value,
                                role: "option",
                                tabIndex: "-1",
                                "aria-label": item.name,
                                onClick: ()=>{
                                    return handleSelect((props === null || props === void 0 ? void 0 : props.showStateName) ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.code);
                                },
                                onKeyDown: (e)=>handleKeyDown(i, e),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "select-dropdown__list-value",
                                    children: (props === null || props === void 0 ? void 0 : props.showStateName) ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.code
                                })
                            }, i);
                        }))
                    ]
                }),
                showError && errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    "aria-live": "polite",
                    role: "region",
                    className: "select-dropdown__error-message",
                    children: errorMessage
                })
            ]
        })
    });
};
SelectDropdown.defaultProps = {
    label: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectDropdown);


/***/ }),

/***/ 8618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectDropdown_wrapper__ot64Z"};

/***/ }),

/***/ 52003:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextArea_wrapper__17KqP"};

/***/ })

}]);